import client from '../../client';

const PROPERTIES = {
  getProperty(id) {
    return client.get(`/sellers/${client.customerId()}/properties/${id}`);
  },

  updateProperty(id, params) {
    return client.put(`/sellers/${client.customerId()}/properties/${id}`, { property: params });
  },

  // For Radar app only
  getRadarProperties(params) {
    return client.get('/radar/properties', { radar: params });
  },

  getRadarProperty(propertyId) {
    return client.get(`/radar/properties/${propertyId}`);
  },
}

export default PROPERTIES;
